import { FC } from "react";
import styled from "styled-components";

/** @public */
export const Styles = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;

  .by-name {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    h1 {
      display: inline;
      font-size: 20px;
      line-height: 24px;
      font-weight: 200;
      margin: 0;
      vertical-align: top;
    }
    .by {
      color: var(--primary-text-color);
      font: var(--title-font);
      font-size: 9px;
      font-weight: bold;
      line-height: 12px;
    }
  }

  .te-logo {
    width: 58px;
    vertical-align: top;
  }
`;

export const Logo: FC<{ noName?: boolean }> = ({ noName }) => {
  return (
    <Styles>
      {noName ? null : (
        <div className="by-name">
          <h1>PV calc</h1>
          <span className="by">by</span>
        </div>
      )}
      <img
        className="te-logo"
        src="/images/logo_te.svg"
        alt="Total Energies Logo"
      />
    </Styles>
  );
};
